import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

const useAgentBuilderStore = create(
  devtools(
    persist(
      (set) => ({
        buildId:       null,
        buildStatus:   null,   // null | QUEUED | BUILDING | DONE | FAILED | TIMED_OUT
        agentId:       null,
        returnPath:    null,   // URL to navigate back to the PRD when pill is clicked
        isMinimized:   false,  // true = panel closed, global pill visible
        pendingExpand: false,  // true = user clicked expand from a different page; PRD page opens panel on mount
        tokenUsage:    null,

        startBuild: ({ buildId, agentId, returnPath }) =>
          set({ buildId, agentId, returnPath, buildStatus: 'QUEUED', isMinimized: false, pendingExpand: false, tokenUsage: null }),

        setStatus:        (buildStatus)   => set({ buildStatus }),
        setMinimized:     (isMinimized)   => set({ isMinimized }),
        setPendingExpand: (pendingExpand) => set({ pendingExpand }),
        setTokenUsage:    (tokenUsage)    => set({ tokenUsage }),

        clearBuild: () =>
          set({ buildId: null, buildStatus: null, agentId: null, returnPath: null, isMinimized: false, pendingExpand: false, tokenUsage: null }),
      }),
      {
        name: 'agent-builder-store',
        partialize: (state) => ({
          buildId:       state.buildId,
          buildStatus:   state.buildStatus,
          agentId:       state.agentId,
          returnPath:    state.returnPath,
          isMinimized:   state.isMinimized,
          pendingExpand: state.pendingExpand,
          tokenUsage:    state.tokenUsage,
        }),
      }
    ),
    { name: 'AgentBuilderStore' }
  )
);

export default useAgentBuilderStore;
